import { Icon } from '@iconify/react';

const Error401 = () => {
  const RedirectToLogin = () => {
    window.location.href = '/auth/login';
  };

  return (
    <div className="min-h-screen bg-light-background flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold text-primary mb-4">401</div>
        <h1 className="text-2xl font-bold text-font-primary mb-3">Session Expired</h1>
        <p className="text-font-secondary mb-6">
          Your session has expired or is no longer valid. Please log in again to continue using the application.
        </p>
        <div>
          <button 
            className="bg-primary hover:bg-primary/90 text-white font-medium py-3 px-6 rounded-lg inline-flex items-center gap-2 transition-colors"
            onClick={RedirectToLogin}
          >
            <Icon icon="mdi:login" className="w-5 h-5" />
            Login Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error401;
